import React from 'react';
import PropTypes from 'prop-types';
import { default as Share} from './Share';
import {
  Grid,
  Typography,
  makeStyles,
  Link,
  ClickAwayListener,
} from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
import { useAtom } from 'jotai';
import {
  displayShareTicketAtom,
  urlTicketAtom,
  ticketAtom,
} from 'Atoms/Ticket';
import { staticDataAtom } from 'Atoms/Common';
import { EmailIcon, SmsIcon, WhatsappIcon, CancelIcon } from 'images/svg';
import { formattingTimeWithoutSeconde, formattingDate } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.containerGrid,
    height: '100%',
    top: 0,
    position: 'fixed',
    marginTop: 0,
    backgroundColor: 'rgba(38, 41, 87, 0.15)',
  },
  title: { ...theme.title, textAlign: 'left' },
  shareContainer: {
    padding: '1rem',
    height: '25%',
    bottom: '0',
    position: 'fixed',
    backgroundColor: '#fff',
    borderRadius: '30px 30px 0 0',
    textAlign: 'center',
    width: '100%',
  },
  shareItems: {
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  label: {
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    '&:hover': {
      textDecoration: 'none',
    },
  },
  iconBlock: {
    width: '90px',
  },
}));
const ShareContainer = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [, setDisplayShareTicket] = useAtom(displayShareTicketAtom);
  const [urlTicket] = useAtom(urlTicketAtom);
  const [staticData] = useAtom(staticDataAtom);
  const [ticket] = useAtom(ticketAtom);
  const date = ticket?.order?.date;
  const countryCode = ticket?.currency?.countryCode;

  const ticketOrderDateFormatted = formattingDate(date, countryCode);
  const ticketOrderTimeFormatted = formattingTimeWithoutSeconde(
    date,
    countryCode,
  );

  const handleDisplayShare = () => {
    setDisplayShareTicket(false);
  };
  const restaurant = staticData?.company?.name;
  const message = `${t(
    'message_share_ticket',
  )} ${restaurant} (${ticketOrderDateFormatted} - ${ticketOrderTimeFormatted}) : [${urlTicket}]`;

  const emailSubject = `${t('message_email_subject')} - ${restaurant}`;

  return (
    <Grid container direction="column" className={classes.root}>
      <ClickAwayListener onClickAway={handleDisplayShare}>
        <div className={classes.shareContainer}>
          <Share />
        </div>
      </ClickAwayListener>
    </Grid>
  );
};

ShareContainer.propTypes = {};

export default ShareContainer;
